import api from './api';

export const toolUsageService = {
   getSummary: ({ from, to }) =>
      api.get('/tool-usage/summary', { params: { from, to } }).then((r) => r.data),
   getTotals: (tool) => api.get('/tool-usage/totals', { params: { tool } }).then((r) => r.data),
   // `tool` is optional - omit it for the combined total across all tools.
   getDaily: ({ tool, from, to }) =>
      api.get('/tool-usage/daily', { params: { tool, from, to } }).then((r) => r.data),
};
